import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { fetchPageBySlug } from '../lib/cms';

export default function Privacy({ isEn }) {
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadData() {
      try {
        const page = await fetchPageBySlug('privatlivspolitik');
        setPageData(page);
      } catch (error) {
        console.error('Error loading privacy page data:', error);
      } finally {
        setLoading(false);
      }
    }
    loadData();
  }, []);

  const lang = isEn ? 'en' : 'da';

  const title = pageData?.title?.[lang] || (isEn ? 'Privacy Policy' : 'Privatlivspolitik');
  const content = pageData?.content?.[lang] || '';
  const seoTitle = pageData?.seo_title?.[lang] || `${title} - Fredericia Isolerings-puder`;
  const seoDesc = pageData?.seo_description?.[lang] || '';

  return (
    <>
      <Helmet>
        <title>{seoTitle}</title>
        <meta name="description" content={seoDesc} />
      </Helmet>

      {/* Hero Section */}
      <section className="relative py-20 bg-brand-dark overflow-hidden border-b border-gray-800">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#1f2937_1px,transparent_1px),linear-gradient(to_bottom,#1f2937_1px,transparent_1px)] bg-[size:5rem_5rem] opacity-10" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="w-full text-left space-y-4">
            <div className="text-xs font-mono text-brand-accent uppercase tracking-wider">
              {isEn ? 'Legal Information' : 'Juridisk information'}
            </div>
            <h1 className="text-4xl sm:text-5xl font-display font-bold text-white tracking-tight">
              {title}
            </h1>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-brand-surface border-b border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-left">
          {loading ? (
            <div className="flex justify-center py-12">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-accent" />
            </div>
          ) : (
            <div 
              className="text-gray-300 space-y-6 leading-relaxed text-sm sm:text-base prose prose-invert max-w-none
                prose-headings:font-display prose-headings:font-bold prose-headings:text-white prose-headings:mt-8 prose-headings:mb-4
                prose-h2:text-xl prose-h2:border-b prose-h2:border-gray-800 prose-h2:pb-2
                prose-h3:text-lg
                prose-p:leading-relaxed prose-p:text-gray-300
                prose-ul:list-disc prose-ul:pl-6 prose-ul:space-y-2
                prose-ol:list-decimal prose-ol:pl-6 prose-ol:space-y-2
                prose-li:text-gray-300
                prose-strong:text-white"
              dangerouslySetInnerHTML={{ __html: content }}
            />
          )}
        </div>
      </section>
    </>
  );
}
